module.exports = __webpack_public_path__ + "static/avatar-83389c3cbc5fab88c54ea80cf57b9327.jpeg";